// Desc: Terms and Conditions page component

import { ConfigurationAtom } from "_states";
import { useRecoilValue } from "recoil";

/**
 * PrivacyPage component
 * @returns {JSX.Element} JSX.Element
 */
const PrivacyPage = () => {
  const configurations = useRecoilValue(ConfigurationAtom);
  return (
    <section className="max-w-7xl mx-auto space-y-8 pb-36 md:px-2 sm:px-4 px-4">
      <div>
        <h2 className="font-semibold text-4xl text-center mb-10">
          Privacy Policy
        </h2>
        <div className="space-y-4">
          <h2 className="font-semibold">Who we are</h2>

          <p>
            <strong>{configurations.site_name}</strong>&nbsp;is committed to
            providing quality services to you and this policy outlines our
            ongoing obligations to you in respect of how we manage your Personal
            Information.
          </p>

          <h2 className="font-semibold">
            What is Personal Information and why do we collect it?
          </h2>

          <p>
            Personal Information is information or an opinion that identifies an
            individual. Examples of Personal Information we collect include:
            names, addresses, email addresses, phone and facsimile numbers.
          </p>

          <p>
            This Personal Information is obtained in many ways including by
            telephone, by email, via our website, from media and publications,
            from other publicly available sources, from cookies and from third
            parties. We don’t guarantee website links or policy of authorised
            third parties.
          </p>

          <p>
            We collect your Personal Information for the primary purpose of
            providing our services to you, providing information to our clients
            and marketing. We may also use your Personal Information for
            secondary purposes closely related to the primary purpose, in
            circumstances where you would reasonably expect such use or
            disclosure. You may unsubscribe from our mailing/marketing lists at
            any time by contacting us in writing or by clicking unsubscribe on
            the emails sent by us. When we collect Personal Information we will,
            where appropriate and where possible, explain to you why we are
            collecting the information and how we plan to use it.
          </p>

          <h2 className="font-semibold">Sensitive Information</h2>

          <p>
            Sensitive information is defined in the Privacy Act to include
            information or opinion about such things as an individual’s racial
            or ethnic origin, political opinions, membership of a political
            association, religious or philosophical beliefs, membership of a
            trade union or other professional body, criminal record or health
            information.
          </p>

          <p>Sensitive information will be used by us only:</p>

          <p>• For the primary purpose for which it was obtained</p>

          <p>
            • For a secondary purpose that is directly related to the primary
            purpose
          </p>

          <p>• With your consent; or where required or authorised by law.</p>

          <h2 className="font-semibold">Third Parties</h2>

          <p>
            Where reasonable and practicable to do so, we will collect your
            Personal Information only from you. However, in some circumstances
            we may be provided with information by third parties. In such a case
            we will take reasonable steps to ensure that you are made aware of
            the information provided to us by the third party.
          </p>

          <h2 className="font-semibold">Disclosure of Personal Information</h2>

          <p>
            Your Personal Information may be disclosed in certain circumstances
            including the following:
          </p>

          <p>• Third parties where you consent to the use or disclosure; and</p>

          <p>• Where required or authorised by law.</p>

          <h2 className="font-semibold">Security of Personal Information</h2>

          <p>
            Your Personal Information is stored in a manner that reasonably
            protects it from misuse and loss and from unauthorized access,
            modification or disclosure.
          </p>

          <p>
            When your Personal Information is no longer needed for the purpose
            for which it was obtained, we will take reasonable steps to destroy
            or permanently de-identify your Personal Information. However, most
            of the Personal Information is or will be stored in client files
            which will be kept by us for a minimum of 7 years.
          </p>

          <h2 className="font-semibold">Access to your Personal Information</h2>

          <p>
            You may access the Personal Information we hold about you and update
            and/or correct it, subject to certain exceptions. If you wish to
            access your Personal Information, please contact us in writing.
          </p>

          <p>
            <strong>We</strong> will not charge any fee for your access request
            but may charge an administrative fee for providing a copy of your
            Personal Information.
          </p>

          <p>
            To protect your Personal Information, we may require identification
            from you before releasing the requested information.
          </p>

          <h2 className="font-semibold">
            Maintaining the Quality of your Personal Information
          </h2>

          <p>
            It is important to us that your Personal Information is up to date.
            We&nbsp;will&nbsp;take reasonable steps to make sure that your
            Personal Information is accurate, complete and up to date. If you
            find that the information we have is not up to date or is
            inaccurate, please advise us as soon as practicable so we can update
            our records and ensure we can continue to provide quality services
            to you.
          </p>

          <h2 className="font-semibold">Policy Updates</h2>

          <p>
            This Policy may change from time to time and is available on our
            website.
          </p>

          <h2 className="font-semibold">
            Privacy Policy Complaints and Enquiries
          </h2>

          <p>
            If you have any queries or complaints about our Privacy Policy,
            please contact us
          </p>

          <p>{configurations.contact_email}</p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPage;
